import type { EmployeePaidHours, PaginatedResponse } from '@pms/shared';
import { api } from '@/lib/api';

export const paidHoursService = {
  async create(input: {
    attendance_date: string;
    hours: number;
    reason: string;
    user_ids: string[];
  }): Promise<EmployeePaidHours[]> {
    const res = await api.post<{ data: EmployeePaidHours[] }>('/paid-hours', input);
    return res.data.data;
  },

  async list(params: {
    status?: 'pending' | 'approved' | 'rejected';
    user_id?: string;
    date_from?: string;
    date_to?: string;
    q?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<EmployeePaidHours>> {
    const res = await api.get<PaginatedResponse<EmployeePaidHours>>('/paid-hours', { params });
    return res.data;
  },

  async approve(id: string): Promise<EmployeePaidHours> {
    const res = await api.patch<{ data: EmployeePaidHours }>(`/paid-hours/${id}/approve`);
    return res.data.data;
  },

  async reject(id: string, rejection_reason: string): Promise<EmployeePaidHours> {
    const res = await api.patch<{ data: EmployeePaidHours }>(`/paid-hours/${id}/reject`, {
      rejection_reason,
    });
    return res.data.data;
  },

  async moveToPending(id: string): Promise<EmployeePaidHours> {
    const res = await api.patch<{ data: EmployeePaidHours }>(`/paid-hours/${id}/move-to-pending`);
    return res.data.data;
  },

  async bulkApproveGroup(groupId: string): Promise<{ approved: number }> {
    const res = await api.patch<{ data: { approved: number } }>(
      `/paid-hours/group/${groupId}/approve`,
    );
    return res.data.data;
  },

  async listMy(params?: { year?: number; month?: number }): Promise<EmployeePaidHours[]> {
    const res = await api.get<{ data: EmployeePaidHours[] }>('/paid-hours/me', { params });
    return res.data.data;
  },
};
